/* eslint-disable @typescript-eslint/no-var-requires */
import { createTheme } from '@mui/material'

import { THEME_NAME } from 'utils/helperConfig'

const IMAGES_PATH = file => {
    try {
        return require(`../${THEME_NAME}/assets/images${file}`)
    } catch {
        return require(`./assets/images${file}`)
    }
}

const check = IMAGES_PATH('/check.svg')
const planBg = IMAGES_PATH('/servicePlans/plan_bg.png')
const newTheme = require(`../${THEME_NAME}/theme`)

export const theme = createTheme(newTheme?.variables)

export const useModalStyles = () => ({
    multiline: {
        width: '100%',
    },
    selectTopic: {
        width: '100%',
    },
    circularProgress: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    maxAmountButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& > button': {
            '&:disabled': {
                color: `${theme.color.link.secondary}`,
                cursor: 'default',
                textDecoration: 'none',
            },
        },
    },
    modalOpenButton: {
        display: 'inline-flex',
        alignItems: 'center',

        '& > div': {
            cursor: 'pointer',
        },
    },
    selectDropDownSelect: {
        display: 'flex',
        minHeight: '41px',
    },
    card: {
        boxShadow: 'none',
        maxWidth: 400,
        margin: 'auto',
    },
    cardContent: {
        border: `1px solid ${theme.color.border.main}`,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        padding: '15px 30px 30px',
        marginBottom: 30,
    },
    cardTitle: {
        fontSize: 40,
        lineHeight: '44px',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: 30,
        [theme.breakpoints.down('md')]: {
            fontSize: 34,
            lineHeight: '38px',
        },
    },
    currencySelect: {
        width: '100%',
        '& .Mui-disabled>input': {
            opacity: 0,
        },
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0,
    },
    MuiDialogContainer: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    paper: {
        backgroundColor: 'white',
        padding: 30,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        outline: 0,
        width: 650,
    },
    paperDialog: {
        backgroundColor: 'white',
        borderRadius: `${theme.variables.paper.borderRadius}`,
        outline: 0,
        position: 'relative',
    },
    transactionFilesBox: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        flexWrap: 'wrap',

        '& div': {
            '& a': {
                color: 'black',
                padding: '0 5px',
                borderRight: '2px solid black',
            },
        },

        '& div:first-of-type': {
            '& a': {
                paddingLeft: '0',
            },
        },

        '& div:last-of-type': {
            '& a': {
                border: 'none',
                paddingRight: '0',
            },
        },
    },
    skeletonModal: {
        padding: '15px 20px 25px',
    },
    paperContainerFullWidth: {
        minWidth: '100%',
        maxWidth: '100%',
    },
    paperDialogWidth: {
        minWidth: 665,
        minHeight: 220,
        overflow: 'hidden',

        [theme.breakpoints.down('md')]: {
            position: 'absolute',
            minWidth: '100%',
            maxWidth: '100%',
            minHeight: '100%',
            margin: '0 auto',
            borderRadius: 0,

            '&::-webkit-scrollbar-thumb': {
                background: '#AFAFAF',
            },
            '&::-webkit-scrollbar': {
                width: 6 + 20,
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
                boxShadow: 'none',
            },

            '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb': {
                border: '10px solid transparent',
                backgroundClip: 'padding-box',
                borderRadius: 100,
            },
        },
    },
    modalFixedHeader: {
        position: 'relative',
        height: 68,
        minWidth: 665,
        background: '#ffffff',
        zIndex: 99,
        borderTopLeftRadius: `${theme.variables.paper.borderRadius}`,
        borderTopRightRadius: `${theme.variables.paper.borderRadius}`,

        [theme.breakpoints.down('md')]: {
            minWidth: '100%',
            maxWidth: '100%',
        },

        [theme.breakpoints.down('sm')]: {
            height: 90,
        },

        '& > h1': {
            maxWidth: 'calc(665px - 70px - 70px)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginLeft: 'auto',
            marginRight: 'auto',
            height: 68,
            padding: '18px 0',
            textAlign: 'center',

            [theme.breakpoints.down('md')]: {
                maxWidth: 'calc(100% - 70px - 70px)',
            },

            [theme.breakpoints.down('sm')]: {
                height: 90,
                paddingTop: 50,
                paddingBottom: 10,
                maxWidth: 'calc(100% - 20px - 20px)',
            },
        },
    },
    modalFixedHeaderNowrap: {
        height: 'auto',
        '& h1': {
            height: 'auto',
            whiteSpace: 'initial',
        },
    },
    modalBackButton: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        height: 68,
        width: 68,
        color: `${theme.color.close.main}`,
        borderRadius: '0',

        [theme.breakpoints.down('sm')]: {
            height: 58,
            width: 58,
        },
    },
    modalCloseButton: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        height: 68,
        width: 68,
        color: `${theme.color.close.main}`,
        borderRadius: '0',
        zIndex: 99,

        [theme.breakpoints.down('sm')]: {
            height: 58,
            width: 58,
        },
    },
    modalSafariBottomNavigation: {
        paddingBottom: 110,
    },
    modalContent: {
        textAlign: 'left',
        padding: '10px 30px 30px',
        overflowY: 'auto',
        maxHeight: 'calc(90vh - 68px)',

        [theme.breakpoints.down('md')]: {
            maxHeight: 'calc(var(--doc-height) - 68px)',
            paddingBottom: '40px',
        },

        [theme.breakpoints.down('sm')]: {
            maxHeight: 'calc(var(--doc-height) - 90px)',
            paddingLeft: 15,
            paddingRight: 15,
        },

        '&::-webkit-scrollbar-thumb': {
            background: '#AFAFAF',
            borderRadius: 100,
        },
        '&::-webkit-scrollbar': {
            width: 6 + 10,
            background: 'white',
        },
        '&::-webkit-scrollbar-track': {
            background: 'white',
            boxShadow: 'none',
        },

        '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb': {
            border: '5px solid white',
            backgroundClip: 'padding-box',
        },
    },
    modalHeader: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 25,
    },
    modalDownloadFileHeader: {
        position: 'relative',
        padding: 15,
    },
    modalHeaderTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',

        '& h6': {
            marginTop: 20,
            color: `${theme.color.text.secondary}`,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
        },

        '& h1': {
            marginTop: '25px',
        },
    },
    modalSuccessContent: {
        textAlign: 'center',
        padding: '5px 20px 30px',
    },
    modalSuccess: {
        textAlign: 'center',

        '& h1': {
            color: `${theme.color.text.main}`,
        },

        '& h6': {
            color: `${theme.color.text.secondary}`,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
        },
        '& strong': {
            color: `${theme.color.link.active}`,
            fontWeight: 600,
        },

        '& a': {
            color: `${theme.color.text.main}`,
            fontSize: 16,
            fontWeight: 600,
        },
    },
    modalSuccessTitle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,

        '& img': {
            marginRight: 15,
            width: 32,
            height: 32,
        },
        '& h1': {
            fontSize: 28,
            fontWeight: 600,
            lineHeight: '34px',
        },
    },
    modalSubtitle: {
        marginBottom: 20,
    },
    modalActiveColor: {
        color: `${theme.color.link.active}`,
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 600,
    },
    modalAlertInfoText: {
        marginTop: 30,

        '& .message': {
            fontSize: '14px !important',
        },
    },
    modalBankDetalsTitle: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 600,
        color: `${theme.color.text.main}`,
    },
    modalBankDetails: {
        textAlign: 'center',
    },
    modalBankDetalsBox: {
        fontSize: 16,
        lineHeight: '20px',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',

        '& > div': {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '14px 0',
        },

        '& dt': {
            fontWeight: 400,
            color: `${theme.color.text.secondary}`,
        },

        '& dd': {
            textAlign: 'right',
            fontWeight: 600,
            color: `${theme.color.text.main}`,
            [theme.breakpoints.down('sm')]: {
                marginLeft: 10,
            },
        },
    },
    modalInfoDetalsBox: {
        border: `1px solid ${theme.color.border.active}`,
        backgroundColor: `${theme.color.bg.main}`,
        borderRadius: `${theme.variables.input.borderRadius}`,
        padding: '15px !important',
        display: 'flex',
        justifyContent: 'center',
    },
    modalInfoDetalsBoxText: {
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        fontSize: 14,
        lineHeight: '18px',
    },
    modalInfoDetalsBoxTitle: {
        fontWeight: 600,
        color: `${theme.color.text.second}`,
        fontSize: 16,
        lineHeight: '20px',
        marginBottom: 5,
    },
    modalInfoDetalsBoxContent: {
        fontWeight: 400,
        color: `${theme.color.text.secondary}`,
        fontSize: 16,
        lineHeight: '20px',
    },
    modalButtonGroupWrap: {
        marginBottom: 0,
        '& :not(:first-child)': {
            marginLeft: 0,
        },
        '& button': {
            flex: '1 33%',
            color: `${theme.color.text.secondary}`,
            borderColor: `${theme.color.border.main}`,
            textTransform: 'none',
            height: 50,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
            [theme.breakpoints.down('md')]: {
                textAlign: 'left',
            },

            '&:hover, &.active, &:active': {
                border: `1px solid ${theme.color.border.active}`,
                backgroundColor: theme.color.button.boxHover,
                color: `${theme.color.text.main}`,
                fontWeight: 600,
            },

            '& .radioBtn': {
                height: 24,
                width: 24,
                minWidth: 24,
                borderRadius: '50%',
                border: `1px solid ${theme.color.border.main}`,
                backgroundColor: '#ffffff',
                marginRight: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                '& .radioBtnInner': {
                    position: 'absolute',
                    height: 8,
                    width: 8,
                    borderRadius: '50%',
                    backgroundColor: '#ffffff',
                },
            },

            '&.active .radioBtn': {
                borderColor: `${theme.color.border.active}`,
                backgroundColor: `${theme.color.border.active}`,
            },
        },
    },
    modalButtonGroupWrapBankAccount: {
        marginBottom: 0,
        width: '100%',
    },
    modalButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        width: '100%',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    modalButtonSecondary: {
        backgroundColor: 'transparent',
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        width: '100%',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',
        border: `1px solid ${theme.color.border.main}`,

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.secondaryHover}`,
        },
    },
    twoButtonsBox: {
        display: 'flex',
        justifyContent: 'space-between',

        '& > button': {
            width: '46%',
        },
    },
    modalButtonCard: {
        marginTop: 20,
    },
    splitter: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        position: 'relative',
        margin: '50px 0 0 0',
        color: theme.color.text.main,
        fontSize: 16,
        lineHeight: '20px',
        marginBottom: 15,
    },
    splitterLine: {
        height: 1,
        width: '100%',
        backgroundColor: theme.color.border.main,
        marginLeft: 20,
    },
    splitterTitle: {
        fontWeight: 400,
        color: theme.color.text.main,
        whiteSpace: 'pre-line',
    },
    splitterAddBankAccount: {
        marginBottom: '30px',
    },
    modalSummary: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    modalSummaryCurrencyOvalImage: {
        width: 54,
        height: 54,
        marginRight: 20,
    },
    total: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
    totalFees: {
        color: `${theme.color.text.main}`,
        fontSize: 16,
        fontWeight: 400,
        textAlign: 'left',

        '& b': {
            color: `${theme.color.text.main}`,
        },
    },
    totalWrap: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    summarySum: {
        fontSize: 24,
        fontWeight: 600,
        color: `${theme.color.link.active}`,
    },
    textFieldInputHalfSize: {
        width: 'calc(50% - 15px)',

        [theme.breakpoints.down('lg')]: {
            width: '100%',
        },
    },
    textFieldInputHalfSizeFlag: {
        width: 'calc(50% - 5px)',

        [theme.breakpoints.down('lg')]: {
            width: '100%',
        },
    },
    selectFlag: {
        '& > div': {
            paddingLeft: 50,
        },
    },
    textFieldInput: {
        height: 50,
        padding: '0 0 0 10px',
        boxShadow: 'none',
        '&:active': {
            borderColor: `${theme.color.border.secondary}`,
        },
    },
    currencySelector: {
        width: 'calc(100% + 15px)',
        borderRadius: '0 !important',
        fontWeight: 600,
        fontSize: 16,
    },
    currencySelectorRoot: {
        width: 170,
        textAlign: 'right',
        paddingRight: 30,
        paddingLeft: 30,
    },
    ledgerLogo: {
        maxWidth: 26,
    },
    ledgerCurrencyCode: {
        color: `${theme.color.text.main}`,
        fontSize: 16,
        fontWeight: '600',
        textTransform: 'capitalize',
        marginLeft: 10,
    },
    checkbox: {
        marginTop: 30,
        flex: 1,
    },
    checkboxLabel: {
        alignItems: 'flex-start',
    },
    checkboxRoot: {
        padding: 0,
        margin: '5px 10px 0 10px',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkBoxBankAccount: {
        marginTop: '2px',
    },
    checkboxGroupMulti: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
    },
    checkboxGroupMultiItem: {
        width: '50%',
        margin: '10px 0 10px -8px',
        marginLeft: '-8px',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    checkboxItem: {
        display: 'flex',
        alignItems: 'center',
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 7px center`,
        borderColor: `${theme.color.checkbox.borderActive}`,
        width: 30,
        height: 30,
    },
    checkboxSmallIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 24,
        height: 24,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxSmallIconChecked: {
        background: `${theme.color.button.outlinedHover} url(${check}) no-repeat 4px center`,
        borderColor: `${theme.color.button.outlinedHover}`,
        width: 24,
        height: 24,
    },
    selectorWithFlag: {
        textAlign: 'center',
        width: '155px',
    },
    selectorFullWidth: {
        width: '100%',
        marginTop: 30,
    },
    selectorFullWidthFlag: {
        width: '100%',
        marginTop: 30,
    },
    selectorFullWidthFlagAndLabel: {
        width: '100%',
        marginTop: 30,
        '&:first-child': {
            marginTop: 0,
        },
        '& label': {
            transform: 'translate(53px, 8px) scale(0.75) !important',
            fontSize: 14,
            fontWeight: '400',
            color: theme.color.text.secondary,
        },
    },
    selectWithFlag: {
        '& .MuiSelect-select': {
            width: '100%',
            textAlign: 'left',
            paddingLeft: 55,
            color: theme.color.text.main,
            fontSize: 16,
            fontWeight: '600',
            paddingTop: 14,
            paddingBottom: 13,
        },

        '& svg.Mui-disabled': {
            display: 'none',
        },
    },
    selectFlagAndLabel: {
        '& > div': {
            paddingLeft: 50,
            color: theme.color.text.main,
            fontSize: 16,
            fontWeight: '600',
        },

        '& svg.Mui-disabled': {
            display: 'none',
        },
    },
    inputAdornmentRightTextField: {
        padding: '25px 15px',
    },
    copyButton: {
        padding: 15,
    },
    copyAddress: {
        fontFamily: `${theme.typography.fontFamily}`,
        padding: 14,
        [theme.breakpoints.down('md')]: {
            padding: '14px 5px 14px 14px',
        },
    },
    maxButtonDiv: {
        fontFamily: `${theme.typography.fontFamily}`,
        padding: 14,
        color: `${theme.color.primary.main}`,
        fontWeight: 700,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('md')]: {
            padding: '14px 5px 14px 14px',
        },

        '&:disabled': {
            color: theme.color.text.secondary,
            cursor: 'default',
            opacity: 0.4,
            textDecoration: 'none',
        },
    },
    separatorBox: {
        padding: '12px 15px',
        display: 'flex',
        alignItems: 'center',
    },
    fullWidthFormControl: {
        width: '100%',
    },
    selectFullWithWithFlag: {
        paddingLeft: '40px',
    },
    helpfulBox: {
        marginTop: 30,
    },
    helpfulInformation: {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '18px',
        color: `${theme.color.text.secondary}`,
    },
    gridSpaceContainer: {
        width: '100%',
        margin: '18px auto 0 auto',
    },
    gridSpaceContainerMt: {
        width: '100%',
        margin: '0 auto 0 auto',
        [theme.breakpoints.down('md')]: {
            margin: '18px auto 0 auto',
        },
    },
    gridMarginTop: {
        width: '100%',
        marginTop: 18,
    },
    gridItemNoPaddingTop: {
        paddingTop: '0 !important',
    },
    maxInput: {
        color: '#23B6EC ',
        fontSize: 16,
        textAlign: 'right',
        textTransform: 'capitalize',
        marginRight: 10,
        fontWeight: 600,
        cursor: 'pointer',
    },
    bankAccountDetailsSpinnerWrap: {
        margin: '50px auto',
        textAlign: 'center',
    },
    bankAccountDetailsCard: {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${theme.color.primary.grey}`,
        borderRadius: `${theme.variables.input.borderRadius}`,
        marginTop: 30,
    },
    bankAccountDetailsCardContent: {
        width: '90%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            paddingBottom: 10,
        },
    },
    bankAccountDetailsCardHeader: {
        fontSize: 16,
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 50,
        borderBottom: `1px solid ${theme.color.primary.grey}`,
    },
    bankAccountInfoDetalsBox: {
        border: `1px solid ${theme.color.border.active}`,
        backgroundColor: `${theme.color.bg.main}`,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
        padding: '15px !important',

        '& .spanUl': {
            margin: '0 0 0 15px',
            padding: 0,
        },

        '& .spanText': {
            position: 'relative',
        },
    },
    bankAccountInfoDetalsBoxText: {
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        fontSize: 14,
    },
    bankAccountInfoDetalsBoxTextWarning: {
        fontWeight: 600,
        color: `${theme.color.status.Canceled}`,
        fontSize: 14,
        lineHeight: '18px',
    },
    bankAccountInfoDetalsBoxWarning: {
        border: `1px solid ${theme.color.status.Canceled}`,
        backgroundColor: `${theme.color.bg.canceled} `,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
        marginTop: 30,
        padding: '15px !important',
    },

    bankAccountInfoDetalsBoxWarningText: {
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        fontSize: 14,
        lineHeight: '18px',
    },
    bankAccountInfoDetalsActiveColor: {
        color: `${theme.color.link.active}`,
    },
    bankAccountDetailsCardRow: {
        color: `${theme.color.text.main}`,

        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: 45,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
            height: 40,
        },
    },

    bankAccountDetailsCardValue: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        overflow: 'visible',
        textAlign: 'right',

        '&::-webkit-scrollbar-thumb': {
            background: theme.color.text.placeholder,
        },
        '&::-webkit-scrollbar': {
            height: 6,
        },
        '&::-webkit-scrollbar-track': {
            background: '#E9ECEF',
            boxShadow: 'none',
        },
    },
    bankAccountDetailsCardValueEl: {
        marginRight: 5,
    },
    bankAccountTransfers: {
        marginTop: 30,
    },
    disabledSelectField: {
        '& > div, & > label': {
            color: '#000 !important',
        },
    },
    disabledTextField: {
        '& > div': {
            color: '#000 !important',
        },
    },
    disabledInputLikeEnabled: {
        backgroundColor: '#fff !important',
        color: '#000 !important',
    },
    selectorDropDown: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        border: `1px solid ${theme.color.border.main}`,
        minHeight: '50px',
        width: '100%',
        '&[disabled]': {
            backgroundColor: 'rgba(221, 221, 221, 0.25)',
        },
    },
    selectorDropDownText: {
        position: 'absolute',
        height: '100%',
        color: `${theme.color.text.main}`,
        '& > div ': {
            position: 'absolute',
            height: '100%',
            alignItems: 'center',
        },
    },
    toSelect: {
        marginTop: '25px',
    },
    messageExchange: {
        marginBottom: '25px',
    },
    selectDropDownArrow: {
        position: 'absolute',
        right: '25px',
    },
    selectDropDownLabel: {
        height: '17px',
        color: `${theme.color.text.secondary}`,
        fontWeight: '400',
        textAlign: 'left',
    },
    selectDropDownLabelDisabled: {
        color: theme.color.text.secondary,
        fontSize: 16,
        fontWeight: '400',
        textAlign: 'left',
        lineHeight: '20px',
    },
    selectDropDownText: {
        fontSize: '15px',
        color: '#000',
        textAlign: 'left',
    },
    selectDropDownTextDisabled: {
        fontSize: 16,
        color: '#666',
        textAlign: 'left',
        lineHeight: '20px',
    },
    selectDropDownCurrencyLogo: {
        maxWidth: 26,
        margin: '0 10px 0 3px',
    },
    formControl: {
        '& .selectorWithAdornment': {
            width: 'calc(100% - 95px)',
            borderBottomRightRadius: 0,
            borderTopRightRadius: 0,
        },
    },
    countryOfResidence: {
        '& > div': {
            paddingLeft: 14,
        },
    },
    dropZone: {
        position: 'relative',
        border: '1.6px dashed #d4d4d4',
        padding: '10px 15px',
        background: 'rgba(0,0,0,0)',
        cursor: 'pointer',
        minWidth: 300,
    },
    beneficiaryDropdown: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    fileName: {
        maxWidth: 225,

        [theme.breakpoints.down('sm')]: {
            maxWidth: 240,
        },

        '& p': {
            display: 'block',
            margin: 0,
            flexWrap: 'wrap',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    removeButton: {
        height: 20,
        width: 20,
        marginLeft: 5,
        marginBottom: 3,

        '& svg': {
            height: 20,
            width: 20,
            fill: `${theme.color.error.main}`,
        },
    },
    warningInfoBox: {
        backgroundColor: 'rgba(235,175,0,0.08)',
        marginTop: 25,
        padding: '15px !important',
        border: '1px solid #EBAF00',
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    warningInfoBoxText: {
        color: '#EBAF00',
        fontSize: 14,
        fontWeight: 600,
    },
    errorInfoBox: {
        backgroundColor: 'rgba(221,51,51,0.08);',
        marginTop: 25,
        padding: '15px !important',
        border: '1px solid #DD3333',
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    errorInfoBoxText: {
        color: '#DD3333',
        fontSize: 14,
        fontWeight: 600,
    },
})

export const useTransactionsStyles = () => ({
    TableContainer: {
        marginBottom: '20px',
        overflowX: 'auto',

        '&::-webkit-scrollbar': {
            height: '12px',
        },
        '& strong, b': {
            fontWeight: 600,
        },
    },

    footerComp: {
        [theme.breakpoints.between('0', undefined)]: {
            marginBottom: '20px',
        },
    },

    menuItem: {
        minHeight: 48,
    },

    transactionsFilterContainer: {
        width: '100%',
        margin: '40px 0 20px 0',
        boxSizing: 'border-box',
    },
    card: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        padding: '30px 15px',
        columnGap: '15px',
        [theme.breakpoints.down('md')]: {
            gap: '0px',
            flexDirection: 'column',
            padding: '25px 25px',
        },
    },
    dateRangePickerHolder: {
        width: '34%',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '30px',
            width: '100%',
        },
        '& > div': {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            columnGap: '30px',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                rowGap: '30px',
            },
        },
    },
    selectWithCheckboxesHolder: {
        width: '17%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            paddingBottom: '30px',
        },
        '& > div': {
            width: '100%',
            margin: '0px',
        },
    },
    simpleSelectHolder: {
        width: '34%',
        display: 'flex',
        columnGap: '15px',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '30px',
            width: '100%',
            flexDirection: 'row',
            columnGap: '30px',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            rowGap: '30px',
        },
    },
    dateRangePickerInput: {
        width: '50%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    simpleSelect: {
        margin: '0px',
        width: '50%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    filterButton: {
        width: '15%',
        margin: '0px',
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        height: '50px',
        color: theme.color.text.light,
        fontWeight: '600',
        fontSize: '16px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
        '&.MuiButton-root:hover.Mui-disabled': {
            backgroundColor: `${theme.color.button.disabled} `,
            color: `${theme.color.button.text}`,
        },
        '&.Mui-disabled': {
            backgroundColor: `${theme.color.button.disabled} `,
            color: `${theme.color.button.text}`,
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '20px 0',
        },
    },
    tableCellInnerHolder: {
        display: 'flex',
        alignItems: 'center',
    },
})

export const useSignStyles = () => ({
    radioGroupBox: {
        border: `1px solid ${theme.color.border.main}`,
        borderRadius: theme.variables.paper.borderRadius,
        padding: '5px 15px',
    },
    radioGroupLabel: {
        alignItems: 'flex-start',
    },
    radioGroupRadio: {
        padding: '10px 0',
        userSelect: 'none',

        '& .radioGroupTitle': {
            fontWeight: 600,
            color: theme.color.text.main,
        },
        '& .radioGroupDetails': {
            color: theme.color.text.secondary,
        },
    },
    detalsBox: {
        border: `1px solid ${theme.color.border.active}`,
        backgroundColor: `${theme.color.bg.main}`,
        borderRadius: `${theme.variables.input.borderRadius}`,
        padding: '15px !important',
    },
    detalsBoxText: {
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        fontSize: 14,
        lineHeight: '18px',
    },
    activeColor: {
        color: `${theme.color.link.active}`,
    },
    submitButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        width: '100%',
        height: 46,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    noMarginTop: {
        marginTop: 0,
    },
    checkbox: {
        marginTop: 30,
    },
    checkboxRoot: {
        padding: 0,
        margin: '3px 10px 0 10px',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkBoxBankAccount: {
        marginTop: '15px',
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 7px center`,
        borderColor: `${theme.color.checkbox.borderActive}`,
        width: 30,
        height: 30,
    },
    card: {
        boxShadow: 'none',
        margin: 'auto',
        minWidth: 500,
        maxWidth: 500,

        [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
        },
    },
    cardContent: {
        border: `1px solid ${theme.color.border.main}`,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        padding: 32,
        marginBottom: 10,

        '&:last-child': {
            paddingBottom: 32,
        },

        [theme.breakpoints.down('sm')]: {
            padding: 24,

            '&:last-child': {
                paddingBottom: 24,
            },
        },
    },
    cardBackBtn: {
        color: theme.color.backButton.text,
        backgroundColor: theme.color.backButton.main,
        pointer: 'cursor',

        '&:hover': {
            backgroundColor: theme.color.backButton.mainHover,
        },
    },
    cardTitleHolder: {
        display: 'flex',
        flexDirection: 'row',
        padding: '16px 0 32px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardTitle: {
        fontSize: 40,
        lineHeight: '44px',
        textAlign: 'center',
        paddingBottom: 20,
        marginBottom: 10,
        [theme.breakpoints.down('md')]: {
            fontSize: 34,
            lineHeight: '38px',
        },
    },
    cardTitle_noSpacing: {
        width: '100%',
        textAlign: 'center',
        fontSize: 40,
        lineHeight: '44px',
        fontWeight: '600',
        [theme.breakpoints.down('md')]: {
            fontSize: 34,
            lineHeight: '38px',
        },
    },
    currencySelect: {
        width: '100%',
        '& .Mui-disabled>input': {
            opacity: 0,
        },
    },
    forgotPassword: {
        textDecoration: 'none',
        color: theme.color.link.active,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '20px',
    },
    ledgerLogo: {
        maxWidth: 26,
    },
    selectFlagAndLabel: {
        '& > div': {
            paddingLeft: 50,
            paddingTop: '11.5px',
            paddingBottom: 11,
            color: theme.color.text.main,
            fontSize: 16,
            fontWeight: '600',
        },

        '& svg.Mui-disabled': {
            display: 'none',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0,
    },
    paper: {
        backgroundColor: 'white',
        padding: '30px 40px',
        borderRadius: `${theme.variables.paper.borderRadius}`,
        outline: 0,
        width: '550px',
    },
    modalHeader: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 25,
    },
    modalCloseButton: {
        position: 'absolute',
        right: '-10px',
        top: '-20px',
        color: `${theme.color.close.main}`,
        [theme.breakpoints.down('md')]: {
            top: '-30px',
        },
    },
    modalButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        width: '100%',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    modalSuccess: {
        textAlign: 'center',
        '& h6': {
            color: `${theme.color.text.secondary}`,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
        },
        '& strong': {
            color: `${theme.color.link.active}`,
            fontWeight: 600,
        },
    },
    modalSuccessTitle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,

        '& img': {
            marginRight: 15,
            width: 32,
            height: 32,
        },

        '& h1': {
            fontSize: 28,
            fontWeight: 600,
            lineHeight: '34px',
        },
    },
    layoutRoot: {
        minHeight: '100vh',
        padding: 0,
        margin: 0,
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        },
    },
})

export const useSettingsPageStyles = () => ({
    root: {
        minHeight: '100vh',
        borderRight: `1px solid ${theme.color.border.main}`,
    },
    dropDownContent: {
        marginTop: 30,
    },
    tabTitle: {
        margin: '50px 0 30px',

        '&.authenticatorWarning': {
            marginTop: 25,
        },

        [theme.breakpoints.down('md')]: {
            margin: '30px 0 20px',

            '&.authenticatorWarning': {
                marginTop: 15,
            },
        },
    },
    recentTransactions: {
        marginTop: 80,
    },
    tabsStyles: {
        minWidth: '120px',

        [theme.breakpoints.down('lg')]: {
            minWidth: '95px',
        },

        '&.Mui-selected': {
            color: theme.color.text.main,
            fontWeight: 600,
        },
    },
    tabSelected: {
        color: theme.color.text.main,
        fontSize: 16,
        lineHeight: '20px',
        textAlign: 'center',
    },
    userNameShortening: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#878E9F',
        color: '#FFFFFF',
        minWidth: 64,
        minHeight: 64,
        borderRadius: '50%',
        marginRight: 20,
        fontWeight: 600,
        fontSize: 20,
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            minWidth: 50,
            minHeight: 50,
        },
    },
    cardMargin: {
        marginBottom: 30,
    },
    button: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',
        paddingLeft: 30,
        paddingRight: 30,

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    buttonOutlined: {
        border: `1px solid ${theme.color.button.border}`,
        color: `${theme.color.button.textSecondary}`,
        borderRadius: `${theme.variables.buttonOutlined.borderRadius}`,
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        minWidth: 110,
        paddingLeft: 30,
        paddingRight: 30,
        height: 38,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontWeight: 600,

        '&:hover, &:active': {
            borderColor: `${theme.color.button.borderActive}`,
            backgroundColor: `${theme.color.button.outlinedHover}`,
        },
    },
    offerBox: {
        display: 'flex',
        flexDirection: 'row',
        margin: '30px 0',
        borderRadius: `${theme.variables.paper.borderRadius}`,
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        minHeight: 186,
        width: '100%',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            height: 'auto',
        },
    },
    offerBoxContent: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        backgroundColor: '#fff',
        padding: 20,
        alignItems: 'center',
        flex: 2,
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,

        [theme.breakpoints.down('sm')]: {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            padding: '20px 15px',
        },
    },
    offerBoxTop: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    offerBoxBottom: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        paddingTop: 20,

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    offerBoxHeader: {
        color: `${theme.color.text.main}`,
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 15,
    },
    offerBoxParagraf: {
        color: `${theme.color.text.secondary}`,
        fontSize: 16,
        marginBottom: 15,
    },
    offerInput: {
        width: '100%',

        '& .copyButton': {
            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
    offerBoxButton: {
        borderRadius: `${theme.variables.button.borderRadius}`,
        minWidth: 188,
        height: 46,

        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    offerBoxImage: {
        height: 'auto',
        width: '100%',
        flex: 0.8,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,

        [theme.breakpoints.down('md')]: {
            minWidth: 300,
        },

        [theme.breakpoints.down('sm')]: {
            minHeight: 190,
            minWidth: 'unset',
            flex: 'none',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
    },
    checkbox: {
        flex: 1,

        [theme.breakpoints.down('md')]: {
            marginTop: 30,
        },

        '& label': {
            alignItems: 'center',
        },

        '& + button': {
            [theme.breakpoints.down('md')]: {
                marginTop: 30,
            },

            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
    },
    checkboxGroup: {
        flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },

        '& label': {
            alignItems: 'center',
            marginRight: 30,

            [theme.breakpoints.down('sm')]: {
                marginRight: 15,
                marginTop: 15,
            },

            '&:last-child': {
                marginRight: 0,
            },
        },

        '& + button': {
            [theme.breakpoints.down('md')]: {
                marginTop: 30,
            },

            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
    },
    checkboxRoot: {
        padding: 0,
        margin: '3px 10px 0 10px',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkBoxBankAccount: {
        marginTop: '15px',
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 7px center`,
        borderColor: `${theme.color.checkbox.borderActive}`,
        width: 30,
        height: 30,
    },
    importantInformation: {
        marginTop: 30,
        '& a': {
            color: `${theme.color.text.main}`,
            fontSize: 16,
            fontWeight: 600,
        },
    },
    modalSuccessContent: {
        textAlign: 'center',
    },
    settingsBackButton: {
        padding: 8,
        background: 'transparent',
        border: 0,
        boxShadow: 'none',
        fontSize: 16,
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        textTransform: 'initial',
        '&:hover,&:focus': {
            background: 'transparent',
            boxShadow: 'none',
        },
    },
    settingsBackButtonIcon: { color: `${theme.color.text.main}` },
})

export const useCardToInformUserStyles = () => ({
    root: {
        display: 'flex',
        marginTop: 42,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
        border: `1px solid ${theme.color.border.main}`,
        height: '300px',
        textAlign: 'center',
    },
    topUpButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        width: 250,
        height: 46,
        fontWeight: 600,
        color: `${theme.color.secondary.main}`,
        textTransform: 'none',

        '&:hover': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    addMoneyHeader: {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 600,
        marginBottom: 30,

        [theme.breakpoints.down('sm')]: {
            fontSize: 20,
            lineHeight: '28px',
        },
    },
    paragraf: {
        color: `${theme.color.text.secondary}`,
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '20px',
        marginBottom: 20,
    },
})

export const useSideBarNavigationStyles = theme => ({
    rootSidebar: {
        minHeight: '100vh',
        height: '100%',
        position: 'fixed',
        backgroundColor: `${theme.color.background.default}`,
        borderRight: `1px solid ${theme.color.border.main}`,
        width: 246,

        [theme.breakpoints.down('lg')]: {
            /* Safari viewport bug fix */
            minHeight: '-webkit-fill-available',
        },

        '& :before, :after': {
            display: 'none',
        },

        '& :focus, :active': {
            backgroundColor: 'transparent',
        },

        '& .navContainer': {
            '&:hover': {
                backgroundColor: `${theme.color.nav.mainHover}`,
                borderRight: `1px solid ${theme.color.border.main}`,
            },
        },

        '& a': {
            padding: '18px 26px',
            display: 'flex',
            alignItems: 'center',

            '&:visited, &:hover, &:active, &:link': {
                color: `${theme.color.text.main}`,
                textDecoration: 'none',
            },
        },

        '& .active': {
            position: 'relative',

            '& .line': {
                content: '',
                width: 3,
                backgroundColor: '#878E9F',
                height: 59,
                position: 'absolute',
                display: 'inline-table',
                left: 0,
            },
        },
        '& .active a': {
            background: 'linear-gradient(90deg, rgba(135, 142, 159, 0.05) 0%, rgba(255, 255, 255, 5e-06) 100%)',
            fontWeight: 600,
        },
    },
    sidebarHeader: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        height: `${theme.variables.navHeight}`,
        borderBottom: `1px solid ${theme.color.border.main}`,
        margin: 0,
        padding: '0 30px',
        backgroundColor: theme.modeVariables.header.background.main,

        [theme.breakpoints.down('md')]: {
            margin: 0,
        },

        '& a': {
            padding: 0,
        },

        '&:active, &:focus': {
            backgroundColor: theme.modeVariables.header.background.main,
        },
    },
    sidebarSeparator: {
        margin: 'auto',
        width: 'calc(100% - 52px)',
        height: 1,
        backgroundColor: `${theme.color.border.main}`,
        padding: '0 26px',
    },
    sidebarLogo: {
        height: `${theme.variables.logo.dashboard.desktop.height}`,
        padding: '0',
    },
    ledgerLogo: {
        maxWidth: 38,
    },
    sidebarNav: {
        paddingTop: 0,
        listStyle: 'none',
        padding: 0,

        '&.scrollBox': {
            overflowY: 'scroll',
        },

        '& li': {
            padding: 20,
        },
    },
    sidebarNavWrap: {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'calc(100% - 1px)',
        WebkitOverflowScrolling: 'touch',

        [theme.breakpoints.down('lg')]: {
            height: 'calc(100% - 70px)',
        },

        '&.playgroundEnabled': {
            [theme.breakpoints.up('lg')]: {
                height: 'calc(100% - 50px)',
            },
        },

        '&::-webkit-scrollbar-thumb': {
            background: '#AFAFAF',
        },
        '&::-webkit-scrollbar': {
            width: 6,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
        },
    },
    sidebarNavZeroBalances: {
        display: 'flex',
        padding: '18px 26px',
        alignItems: 'center',
        cursor: 'pointer',
        gap: 10,
    },
    zeroBalancesText: {
        whiteSpace: 'nowrap',
    },
    zeroBalancesSwitcher: {
        display: 'flex',
        alignItems: 'center',
    },
    accountsList: {
        padding: '4px 0',
    },
    assetsList: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .buttonWrap': {
            cursor: 'pointer',
            padding: 15,
            maxWidth: 50,

            '&.disabled': {
                display: 'none',
            },

            '& > div': {
                height: 20,
            },
        },
        '& .iconWrap': {
            display: 'flex',
            alignItems: 'center',
        },
        '& > a': {
            width: '100%',

            '& + .buttonWrap': {
                width: 'calc(100% - 50px)',
            },
        },
    },
    list: {
        padding: 0,

        '& > a': {
            padding: 0,
        },
    },
    listItem: {
        padding: '11px 26px !important',

        '& p': {
            fontWeight: 400,
        },

        '&.active': {
            padding: '5px 24px',
            cursor: 'default',

            '& p': {
                fontWeight: 600,
            },

            '& .listItemWrap': {
                backgroundColor: `${theme.color.nav.mainHover}`,
                borderRadius: `${theme.variables.buttonOutlined.borderRadius}`,
                padding: 6,
            },
        },

        '& .listItemWrap': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
        },
    },
    listItemLogo: {
        height: 20,
        width: 20,
    },
    listItemValue: {
        marginLeft: 7,
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '20px',
    },
})

export const useServicePlanStyles = () => ({
    root: {
        maxWidth: 820,
        margin: '50px auto',
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
    },
    modalRoot: {
        maxWidth: 520,
        margin: '50px auto',
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
    },
    skeleton: {
        marginTop: 50,
    },
    wrap: {
        padding: 15,

        '& h3': {
            marginTop: 0,
        },
    },
    serviceHeaderWrap: {
        marginLeft: 15,
    },
    serviceHeader: {
        '& h3': {
            fontSize: 28,
            lineHeight: '36px',
            fontWeight: 600,
            marginTop: 15,
            marginBottom: 5,

            [theme.breakpoints.down('md')]: {
                fontSize: 22,
                lineHeight: '26px',
            },
        },
        '& p': {
            marginBottom: 25,
        },
    },
    modalSuccessContent: {
        textAlign: 'center',
    },
    serviceFooter: {
        padding: 15,
        marginTop: 50,
    },
    serviceFooterAction: {
        '& .grid-item': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
    },
    serviceFooterList: {
        marginTop: 20,
    },
    listTitle: {
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 600,
    },
    listItems: {
        columnCount: 2,

        [theme.breakpoints.down('sm')]: {
            columnCount: 1,
        },
    },
    listItem: {
        paddingLeft: 0,

        '& img': {
            height: 20,
            width: 20,
            marginRight: 10,
        },
    },
    itemText: {
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 400,
    },
    servicePlanTitle: {
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '28px',
        marginBottom: 0,
    },
    planCard: {
        border: `1px solid ${theme.color.border.main}`,
        padding: 1,
        height: 232,
        margin: 15,

        '& button': {
            width: '100%',
            height: '100%',
        },
        '&.active': {
            border: `2px solid ${theme.color.border.active}`,
            padding: 0,
        },
    },
    planCardAction: {
        height: '100%',
    },
    planCardContent: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        textAlign: 'left',
    },
    planTitle: {
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '20px',
        color: `${theme.color.text.main}`,
        marginBottom: 5,
    },
    planDescription: {
        fontSize: 16,
        lineHeight: '20px',
        color: `${theme.color.text.secondary}`,
    },
    planHeader: {
        width: '100%',
    },
    planPrice: {
        fontWeight: 600,
        fontSize: 22,
        lineHeight: '24px',
        color: `${theme.color.text.main}`,
    },
    planFooter: {
        width: '100%',

        '& hr': {
            marginTop: 20,
            backgroundColor: `${theme.color.border.main}`,
            height: 1,
            border: 'none',
        },
    },
    planServiceIcons: {
        display: 'flex',
        margin: '25px 0 0',
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: 32,

        '& img': {
            marginLeft: 9,
            height: 32,
            width: 32,

            '&:first-child': {
                marginLeft: 0,
            },
        },
    },
    buttonNext: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        height: 46,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        textTransform: 'none',
        boxShadow: 'none',
        paddingLeft: 30,
        paddingRight: 30,
        width: '100%',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    arrowNext: {
        marginLeft: 10,
    },
    buttonPrev: {
        border: `1px solid ${theme.color.border.main}`,
        color: `${theme.color.button.textSecondary}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        minWidth: 110,
        paddingLeft: 30,
        paddingRight: 30,
        height: 46,
        cursor: 'pointer',
        fontWeight: 600,
        width: '100%',

        '&:hover, &:active': {
            borderColor: `${theme.color.button.borderActive}`,
            backgroundColor: `${theme.color.button.outlinedHover}`,
            color: `${theme.color.button.textSecondary}`,
        },
    },
    arrowPrev: {
        marginRight: 10,
        transform: 'rotate(180deg)',
    },
    servicePlanWrap: {
        padding: 30,

        [theme.breakpoints.down('md')]: {
            padding: 15,
        },
    },
    servicePlanHeader: {
        '& h3': {
            fontSize: 28,
            lineHeight: '36px',
            fontWeight: 600,
        },

        '& h4': {
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 600,
            marginTop: 15,
        },
    },
    servicePlanDetails: {
        marginTop: 25,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        backgroundImage: `url(${planBg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: 150,
    },
    servicePlanDetailsWrap: {
        padding: 20,
        display: 'flex',
        justifyContent: 'space-between',
        height: '100%',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    servicePlanInfo: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 110,
    },
    servicePlanDisplayName: {
        fontSize: 24,
        lineHeight: '28px',
        fontWeight: 600,
        color: '#ffffff',

        [theme.breakpoints.down('sm')]: {
            fontSize: 20,
            lineHeight: '22px',
        },
    },
    servicePlanDescription: {
        marginTop: 5,
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 500,
        color: '#ffffff',
    },
    servicePlanPrice: {
        fontSize: 24,
        lineHeight: '28px',
        fontWeight: 600,
        color: '#ffffff',

        [theme.breakpoints.down('sm')]: {
            marginTop: 15,
        },
    },
    servicePlanIcons: {
        display: 'flex',

        [theme.breakpoints.down('sm')]: {
            marginTop: 15,
        },

        '& img': {
            width: 32,
            height: 'auto',
            marginLeft: 10,

            [theme.breakpoints.down('sm')]: {
                marginLeft: 0,
                marginRight: 10,
            },
        },
    },
    servicePlanFees: {
        marginTop: 30,
    },
    servicePlanFooterAction: {
        marginTop: 40,
    },
    checkboxRoot: {
        padding: 0,
        margin: '5px 10px 0 10px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `#FFFFFF url(${check}) no-repeat center center`,
        width: 30,
        height: 30,
    },
    modalHeader: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 25,
    },
    modalCloseButton: {
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        color: `${theme.color.close.main}`,
        [theme.breakpoints.down('md')]: {
            top: '-30px',
        },
    },
    modalSuccess: {
        textAlign: 'center',
        '& h6': {
            color: `${theme.color.text.secondary}`,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
        },
        '& strong': {
            color: `${theme.color.link.active}`,
            fontWeight: 600,
        },
    },
    modalSuccessTitle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,

        '& img': {
            marginRight: 15,
            width: 32,
            height: 32,
        },
    },
    modalSuccessFooter: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: 20,
    },
    modalButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        minWidth: 320,
        height: 46,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        marginTop: 30,
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    documentsTypesListItem: {
        display: 'inline-flex',
        flexWrap: 'wrap',
        padding: '0 10px 0 0',
        width: 'auto',
    },
    documentsTypesListItemText: {
        flex: 'none',
    },
    downloadFileBox: {
        marginTop: 10,
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        textDecoration: 'none',
        color: `${theme.color.text.active}`,
    },
})

export const useHeaderStyles = theme => ({
    root: {
        minHeight: `${theme.variables.navHeight}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexGrow: 1,
        background: theme.modeVariables.header.background.main,
        padding: '0 24px',
    },
    headerContainer: {
        background: theme.modeVariables.header.background.main,
    },
    headerLeftMenu: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        border: `1px solid ${theme.modeVariables.header?.border}`,
        borderRadius: '8px',
        padding: '8px 12px',
        cursor: 'pointer',

        [theme.breakpoints.up('md')]: {
            minWidth: 360,
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    headerLeftMenuOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },

    menuButton: {
        marginRight: theme.spacing(2),
    },
    headerLogo: {
        height: theme.variables.logo.dashboard.desktop.height,
    },
    title: {
        flexGrow: 1,
    },
    userBox: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        cursor: 'pointer',
        color: theme.modeVariables.header.text.main,
    },
    userNameShortening: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFFFFF',
        borderRadius: '50%',
        fontWeight: 600,
        fontSize: 14,
        textTransform: 'uppercase',
        position: 'relative',
        marginRight: 10,
        minHeight: 38,
        minWidth: 38,
        backgroundColor: 'transparent',
    },
    userNameWrap: {
        wordBreak: 'break-word',
        [theme.breakpoints.down('md')]: {
            marginRight: '10px',
        },
    },
    userName: {
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '20px',
    },
    userMenu: {
        display: 'flex',
        '&:focus': {
            outline: 'none',
        },
    },
    userMenuImage: {
        '& img': {
            padding: 15,
            maxWidth: 84,
        },
    },
    userMenuProfile: {
        padding: '15px 15px 15px 0',
    },
    userMenuProfileName: {
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 600,
    },
    userMenuProfileEmail: {
        color: theme.color.text.secondary,
        fontSize: 14,
    },
    userMenuProfileId: {
        fontSize: 14,
        marginTop: 0,
        lineHeight: '18px',
        color: theme.modeVariables.header.text.main,
        fontWeight: 'normal',
        '& > span': {
            color: '#878E9F',
            display: 'flex',
            '& > div': {
                columnGap: 5,
                marginLeft: 2,
            },
        },
    },
    userMenuProfileButtonsWrap: {
        padding: '0 12px',

        [theme.breakpoints.down('md')]: {
            padding: '0 24px',
        },

        '& > div > div': {
            width: '100%',
        },
    },
    userMenuProfileCompany: {
        padding: '10px 0px 20px',
    },
    userMenuItems: {
        borderTop: 'none',

        [theme.breakpoints.down('md')]: {
            borderTop: `1px solid ${theme.modeVariables.header.border}`,
        },
    },
    userLogoutBox: {
        display: 'flex',
        cursor: 'pointer',
    },
    userLogoutIcon: {},
    buttonWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: '30px',

        [theme.breakpoints.down('md')]: {
            gap: 0,
            marginLeft: '20px',
        },
    },
    buttonOutlined: {
        border: `1px solid ${theme.color.border.main}`,
        color: `${theme.color.button.textSecondary}`,
        borderRadius: `${theme.variables.buttonOutlined.borderRadius}`,
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        minWidth: 110,
        paddingLeft: 30,
        paddingRight: 30,
        height: 38,
        cursor: 'pointer',
        fontWeight: 600,
        marginRight: 30,
        fontSize: 14,

        [theme.breakpoints.down('lg')]: {
            paddingLeft: 15,
            paddingRight: 15,
        },

        '&:hover, &:active': {
            borderColor: `${theme.color.button.borderActive}`,
            backgroundColor: `${theme.color.button.outlinedHover}`,
            color: `${theme.color.button.textSecondary}`,
        },
    },
    userLogoutText: {
        fontWeight: 400,
        fontSize: 16,
        marginLeft: 8,

        [theme.breakpoints.down('md')]: {
            display: 'none',
        },

        color: theme.modeVariables.header.text.main,
    },
    menuItem: {
        padding: '0',

        '& img': {
            marginRight: 15,
        },
        '& a': {
            fontSize: 16,
            display: 'flex',
            textDecoration: 'none',
            alignItems: 'center',
            color: theme.modeVariables.header.text.secondary,
            padding: '16px 12px',
            lineHeight: '16px',
            width: '100%',

            [theme.breakpoints.down('md')]: {
                padding: '16px 24px',
            },

            '&:hover': {
                backgroundColor: theme.modeVariables.header.background?.hover,
            },
        },
    },
    accountsMenu: {
        borderTop: `1px solid ${theme.color.border.main}`,
    },
    formControl: {
        '& ::before': {
            borderBottom: 0,
        },
    },
    ledgerMenu: {
        fontSize: 16,
        lineHeight: '20px',

        '& .MuiSelect-selectMenu': {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '20px',

            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
    },
    ledgerMenuItem: {
        fontSize: 16,
        lineHeight: '20px',
    },
    circularProgress: {
        height: 54,
    },
    accountMenuItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    accountDropDownButton: {
        display: 'flex',
        justifyContent: 'space-between',
        border: `1px solid ${theme.color.border.main}`,
        height: '34px',
        minWidth: '139px',
        color: '#000',
        fontWeight: 600,
        fontSize: 14,
        textTransform: 'capitalize',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            marginBottom: '1.5em',
        },
    },
    accountDropDownButtonDesktop: {
        marginLeft: '20px',
    },
    accountDropDownMenuWrapper: {
        zIndex: 1299,
    },
    accountDropDownMenu: {
        backgroundColor: theme.modeVariables.header.background.main,

        [theme.breakpoints.up('md')]: {
            border: `1px solid ${theme.modeVariables.header.border}`,
            borderTop: 'none',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
        },
    },
    accountDropDownMenuItems: {
        padding: 0,
    },
    selectDropDownArrow: {
        marginLeft: '10px',
    },
    selectDropDownText: {
        color: theme.color.text.secondary,
    },
    profilesMenuItems: {
        '& div': {
            width: 'auto',
        },
        '&:last-child': {
            borderBottom: 0,
        },
        padding: theme.spacing(1.5),
        border: 'none',
        borderBottom: `1px solid ${theme.modeVariables.header.border}`,
        '& > div': {
            width: '100%',
        },
        '&:hover': {
            backgroundColor: theme.modeVariables.header.background?.hover,
        },
    },
    profilesMenuItemsCurrent: {
        '&:first-child': {
            borderRadius: 0,
        },
    },
    userMenuProfileHeader: {
        color: theme.modeVariables.header.text.main,
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 600,
    },
    mainHeaderBackground: {
        background: theme.modeVariables.header.background.main,
    },
    mobileMenuButton: {
        '& svg': {
            color: theme.modeVariables.header.text.main,
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
})

export const useAlertComponentsStyles = () => ({
    root: {
        backgroundColor: `${theme.color.primary.white}`,
        height: '50px',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            height: '105px',
        },
    },
    innerBox: {
        backgroundColor: `${theme.color.primary.white}`,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '50px',
        position: 'fixed',
        zIndex: 1200,
        borderBottom: '1px solid #DDDDDD',
        [theme.breakpoints.down('md')]: {
            height: '105px',
        },
    },
    warningImg: {
        margin: '0 15px',
    },
    learnMore: {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    infoDetalsBox: {
        border: `1px solid ${theme.color.border.active}`,
        backgroundColor: `${theme.color.bg.main}`,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
        padding: '15px !important',

        '& .spanText': {
            position: 'relative',
            left: '-10px',
        },
    },
    infoDetalsBoxText: {
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        fontSize: 14,
        lineHeight: '18px',
    },
    bankAccountInfoDetalsActiveColor: {
        color: `${theme.color.link.active}`,
    },
})

export const useLegalStyles = () => ({
    root: {
        padding: '0px 100px 0px 100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .aboutComp': {
            width: '100%',
            maxWidth: '1240px',
        },

        [theme.breakpoints.down('lg')]: {
            padding: '0px 100px 0px 100px',
        },

        [theme.breakpoints.down('lg')]: {
            padding: '0px 15px 0px 15px',
            marginBottom: '30px',
        },
    },
    headerComponent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '60px 0 60px 0',
        fontStyle: 'normal',
        textAlign: 'center',

        '& > *': {
            zIndex: '100',
        },

        '& > h1': {
            marginBottom: '10px',
            padding: '0px',
            fontWeight: '600',
            lineHeight: '44px',
        },

        '& > h3': {
            margin: '0px',
            padding: '0px',
            fontWeight: '600',
            lineHeight: '24px',
        },

        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            textAlign: 'left',
            margin: '10px 0px 30px',
        },
    },
    legalPagesText: {
        lineHeight: '23px',
        zIndex: '100',
        '& > .paragraphSection': {
            fontWeight: 'bolder',
            color: '#333',
        },
        '& > p': {
            color: theme.color.text.secondary,
            fontSize: '16px',

            '& > a': {
                fontWeight: '600',
                color: theme.color.text.main,
                textDecoration: 'underline',
                cursor: 'pointer',
            },
        },

        '& > h3': {
            fontSize: '28px',
            fontWeight: '600',
            lineHeight: '34px',
        },

        '& > h1': {
            fontSize: '40px',
            fontWeight: '600',
            lineHeight: '44px',
        },

        '& > h4': {
            fontWeight: '400',
            fontStyle: 'normal',
            fontSize: '20px',
            lineHeight: '26px',
            color: theme.color.text.secondary,
        },

        [theme.breakpoints.down('lg')]: {
            marginTop: '15px',
        },

        [theme.breakpoints.down('md')]: {
            margin: '0px 15px 0px 0px',
        },
    },
    dottedList: {
        '& > p': {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',

            '& > a': {
                fontWeight: '600',
                color: theme.color.text.main,
                textDecoration: 'underline',
                cursor: 'pointer',
            },

            '& > div': {
                '& > a': {
                    fontWeight: '600',
                    color: theme.color.text.main,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                },
            },
        },

        '& > p::before': {
            content: "''",
            width: '16px',
            minWidth: '16px',
            height: '16px',
            background: 'white',
            borderRadius: '14px',
            border: '5.71px solid #23B6EC',
            marginRight: '20px',
            fontSize: '16px',
        },
    },
})

export const useAcquiringStyles = () => ({
    enableAcquiringButton: {
        color: `${theme.color.primary.main}`,
        height: 38,
        width: '188px',
        padding: '6px 23px',
        fontSize: '16px',
        boxShadow: 'none',
        fontWeight: 600,
        lineHeight: '20px',
        borderRadius: '19px',
        textTransform: 'none',
        backgroundColor: `${theme.color.primary.light}`,

        '&:hover': {
            backgroundColor: `${theme.color.primary.light}`,
        },
    },

    formControlLabelRoot: {
        margin: '20px 0px',
    },
    tabsHeader: {
        fontFamily: `${theme.typography.fontFamily}`,
        fontSize: '20',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 24,
        letterSpacing: 0,
        textAlign: 'left',
    },
    acquiringApiCredentialsCard: {
        marginTop: 20,
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '0 30px',
    },
    acquiringTables: {
        display: 'flex',
        columnGap: '20px',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
        },
    },
    acquiringApiCredentialsTable: {
        flex: 1,
        marginBottom: 20,
    },
    box: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 20px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            padding: '20px 10px 35px 10px',
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
        '& .dateContainer': {
            display: 'flex',
            width: '100%',
            '& >* ': {
                width: '100%',
                marginRight: 20,
            },
            [theme.breakpoints.down('lg')]: {
                marginBottom: 20,
                justifyContent: 'space-between',
                '& >*:last-child': {
                    marginRight: 0,
                },
            },

            [theme.breakpoints.down('md')]: {
                width: '100%',
                marginBottom: 0,
                flexDirection: 'column',

                '& > div': {
                    marginRight: 0,
                    marginBottom: 20,
                },
                '& > div:last-child': {},
            },
        },
    },
    card: {
        boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
        margin: '20px 0',
    },
    selectInputs: {
        margin: '0 20px 0 0',
    },
    filterButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        textTransform: 'none',
        boxShadow: 'none',
        width: '180px',
        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '20px auto 0 auto',
        },
    },
    acquiringSettlementsAdditionalCard: {
        display: 'flex',
        backgroundColor: '#F6F6F6',
        height: '60px',
        borderRadius: '8px',
    },
    acquiringSettlementsAdditionalCardDetails: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
})

export const useTableStyles = () => ({
    tableCard: {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${theme.color.primary.grey}`,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        marginTop: '15px',
    },
    tableCardContent: {
        padding: '0 24px',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
            padding: '0px 20px 30px 20px',
        },
    },
    tableCardHeader: {
        fontSize: 16,
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 50,
        borderBottom: `1px solid ${theme.color.primary.grey}`,
        position: 'relative',
        '& span': {
            cursor: 'pointer',
            padding: '5px',
            marginLeft: '15px',
        },
    },
    threeColumnTableCardHeader: {
        fontSize: 16,
        fontWeight: 600,
        color: `${theme.color.text.main}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 50,
        borderBottom: `1px solid ${theme.color.primary.grey}`,
    },
    tableCardRow: {
        display: 'flex',
        justifyContent: 'space-between',
        height: 45,
        alignItems: 'center',
    },
    tableCardValue: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        overflow: 'auto',
        whiteSpace: 'nowrap',
    },
    splitTableCellName: {
        color: `${theme.color.text.secondary}`,
        fontSize: '14px',
    },
    splitTableCellValue: {
        fontWeight: 600,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    buttonBig: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        width: '100%',
        height: 50,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },
    },
    buttonWhite: {
        backgroundColor: `${theme.color.primary.white}`,
        color: `${theme.color.text.dark}`,
        border: '1px solid #DDDDDD',

        '&:hover, &:active': {
            backgroundColor: `${theme.color.primary.grey}`,
        },
    },
    tableCardHeaderCopy: {
        position: 'absolute',
        right: '0',
        textDecoration: 'none',
        color: `${theme.color.primary.main}`,
    },
    transactionsTableContainer: {
        width: '100%',
        borderRadius: theme.variables.paper.borderRadius,
        overflowY: 'hidden',
        overflowX: 'auto',
        scrollbarColor: `${theme.color.text.placeholder} #E9ECEF`,
        scrollbarWidth: 'thin',

        '&::-webkit-scrollbar-thumb': {
            background: theme.color.text.placeholder,
        },
        '&::-webkit-scrollbar': {
            height: 6,
        },
        '&::-webkit-scrollbar-track': {
            background: '#E9ECEF',
            boxShadow: 'none',
        },
    },
    transactionsTable: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.variables.paper.borderRadius,
    },
    transactionTableRow: {
        cursor: 'pointer',
        '& > td': {
            borderBottom: 'unset',
            padding: '10px 15px',
        },
        '& > td:first-child': {
            [theme.breakpoints.down('md')]: { minWidth: 175 },
        },
        '& > td:nth-child(2)': {
            [theme.breakpoints.down('md')]: { minWidth: 100 },
        },
    },
    tableCellArrowBox: {
        fontWeight: 600,
        color: theme.color.primary.black,
    },
})

export const use2FAAuthenticatorStyles = () => ({
    twoFALogo: {
        display: 'block',
        padding: '15px 30px 15px 15px',
        [theme.breakpoints.down('lg')]: {
            padding: 0,
            marginRight: 20,
        },
    },
    twoFAWrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 20,
        padding: 15,
        border: `1px solid ${theme.color.border.active}`,
        borderRadius: theme.variables.paper.borderRadius,
        background: theme.palette.background.paper,
        alignItems: 'center',

        '&.signIn': {
            minWidth: 500,
            padding: 40,
            border: `1px solid ${theme.color.border.main}`,
            [theme.breakpoints.down('sm')]: {
                padding: 20,
                margin: '10px 0',
                minWidth: 'unset',
            },
        },
    },
    twoFATitle: {
        color: `${theme.color.text.main}`,
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '24px',
        marginBottom: 25,
        textAlign: 'center',

        '&.signIn': {
            fontSize: 28,
            lineHeight: '34px',
            marginBottom: 40,
            width: 'min-content',
            [theme.breakpoints.down('sm')]: {
                fontSize: 24,
                lineHeight: '30px',
                marginBottom: 30,
            },
        },
    },
    twoFACheckBox: {
        marginTop: 25,
    },
    twoFACheckBoxLabel: {
        color: `${theme.color.text.secondary}`,

        '& strong': {
            color: `${theme.color.text.main}`,
        },
    },
    twoFAText: {
        color: `${theme.color.text.secondary}`,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',

        [theme.breakpoints.down('sm')]: {
            marginTop: 10,
            textAlign: 'center',
        },
    },
    twoFAClearButton: {
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        height: 40,
        fontWeight: 600,
        minWidth: 90,
    },
    twoFAButton: {
        backgroundColor: `${theme.color.button.main}`,
        borderRadius: `${theme.variables.button.borderRadius}`,
        fontSize: 16,
        lineHeight: '18px',
        height: 40,
        fontWeight: 600,
        color: `${theme.color.button.text}`,
        textTransform: 'none',
        boxShadow: 'none',
        minWidth: 150,
        '&:hover': {
            backgroundColor: `${theme.color.button.mainHover}`,
        },

        '&.disablePointerEvents': {
            pointerEvents: 'none',
        },
    },
    twoFAButtonBox: {
        [theme.breakpoints.down('sm')]: {
            marginTop: 25,
            marginBottom: 10,
        },
    },
    authContainer: {
        display: 'flex',
        flexDirection: 'row',
    },

    authInput: {
        width: 45,
        height: 45,
        padding: 0,
        fontSize: 24,
        textAlign: 'center',
        marginRight: 12,
        textTransform: 'uppercase',
        color: '#494949',
        border: '1px solid #d6d6d6',
        borderRadius: 4,
        background: '#fff',
        backgroundClip: 'padding-box',
        MozAppearance: 'textfield',

        [theme.breakpoints.down('sm')]: {
            width: 32,
            height: 36,
            fontSize: 20,
        },

        '&:last-child': {
            marginRight: 0,
        },

        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },

        '&:focus': {
            appearance: 'none',
            outline: 0,
            boxShadow: '0 0 0 3px rgb(131 192 253 / 50%)',
        },
    },
    progressBar: {
        marginTop: 10,
        marginBottom: 10,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    checkboxRoot: {
        padding: 0,
        margin: '2px 10px 0 10px',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 7px center`,
        borderColor: `${theme.color.checkbox.borderActive}`,
        width: 30,
        height: 30,
    },
})

export const useSelectInputs = () => ({
    selectInputs: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            maxHeight: 50,
            paddingRight: '8px',
        },
        // '& .MuiOutlinedInput-input': {
        //     padding: '14px 7px',
        // },
        '& .MuiInputLabel-outlined': {
            transform: 'translate(14px, 16px) scale(1)',

            '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75)',
            },
        },
        '& .MuiSvgIcon-root': {
            height: '20px',
            width: '20px',
        },
        '& .Mui-disabled': {
            paddingRight: '14px',
            '& > input:not(.MuiSelect-nativeInput)': {
                backgroundColor: 'transparent',
            },
        },
    },
    selectCheckboxRoot: {
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    selectCheckboxIcon: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.color.border.main}`,
        width: 20,
        height: 20,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    selectCheckboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 4px center`,
        backgroundSize: '11px 11px',
        width: 20,
        height: 20,
    },
})

export const useFeeSummaryStyles = () => ({
    modalSummary: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    modalSummaryImg: {
        width: 54,
        height: 54,
        marginRight: 20,

        [theme.breakpoints.down('sm')]: {
            width: 45,
            height: 45,
            marginRight: 10,
        },
    },
    modalSummaryAmountsHolder: {
        width: '100%',
        display: 'flex',
        whiteSpace: 'nowrap',
        justifyContent: 'space-between',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            whiteSpace: 'initial',
            justifyContent: 'flex-end',
        },
    },
    amountsColumnA: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    totalFees: {
        color: theme.color.text.secondary,
        fontSize: 16,
        fontWeight: 400,
        textAlign: 'left',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },

        '& b': {
            color: theme.color.text.main,
        },
    },
    amountsColumnB: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
        },
    },
    amountsExchgRate: {
        whiteSpace: 'nowrap',
        color: `${theme.color.text.placeholder}`,
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            // textAlign: 'left',
        },
    },
    amountsSumAfterFee: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
        justifyContent: 'flex-end',
    },
    amountsSummarySum: {
        fontSize: 20,
        fontWeight: 600,
        color: `${theme.color.text.active}`,
        alignSelf: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            fontSize: 22,
            lineHeight: '26px',
            wordBreak: 'break-word',
        },
    },
})

export const cardFormButtonBoxStyles = () => ({
    buttonBoxWrap: {
        marginTop: 30,
    },
    buttonBox: {
        display: 'flex',
        border: `1px solid ${theme.color.border.main}`,
        borderRadius: `${theme.variables.paper.borderRadius}`,
        marginBottom: 15,
        width: '100%',
        justifyContent: 'flex-start',
        padding: 0,

        '&:hover, &:active, &:focus': {
            backgroundColor: `${theme.color.button.outlinedHover}`,
        },

        '&:last-child': {
            marginBottom: 0,
        },

        '& img': {
            padding: 15,
        },
    },
    textBox: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        width: 'calc(100% - 68px - 58px)',
        textAlign: 'left',
        padding: '8px 0',

        '& h5': {
            color: `${theme.color.text.main}`,
            fontWeight: '600',
        },

        '& p': {
            color: `${theme.color.text.secondary}`,
            fontWeight: '400',
        },
    },
    arrow: {
        padding: 15,
        display: 'flex',
        alignItems: 'center',
    },
})

export const useWizardStyles = () => ({
    wizard: {
        marginTop: 30,
        paddingBottom: 30,
        minHeight: 'calc(100vh - 80px - 30px - 50px)',

        [theme.breakpoints.down('sm')]: {
            marginTop: 20,
            minHeight: 'calc(100vh - 80px - 20px - 20px)',
            paddingBottom: 20,
        },
    },
    wizardAlert: {
        maxWidth: 650,
        margin: 'auto',
        padding: '0 15px',
    },
    componentWrap: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 20px',
        margin: '0 60px',
        flexWrap: 'wrap',

        [theme.breakpoints.down('md')]: {
            margin: 0,
        },

        '&.paddingTop': {
            paddingTop: 40,

            [theme.breakpoints.down('sm')]: {
                paddingTop: 10,
            },
        },
    },
    stepper: {
        padding: '50px 15px',

        [theme.breakpoints.down('sm')]: {
            padding: '15px 0px 20px',
        },
    },
    circle: {
        height: 20,
        width: 20,
        borderRadius: '50%',
        backgroundColor: '#DEE2E6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& > svg': {
            height: '14px',
            width: '14px',
        },

        '&.active': {
            backgroundColor: '#60D956',

            '& > svg': {
                color: '#ffffff',
            },
        },

        '&.completed': {
            backgroundColor: '#60D956',

            '& > svg': {
                color: '#ffffff',
            },
        },
    },
    buttonBoxWrap: {
        marginTop: 30,
    },
    checkboxRoot: {
        padding: 0,
        margin: '5px 10px 0 10px',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkboxIcon: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #DDDDDD',
        width: 30,
        height: 30,
        borderRadius: `${theme.variables.checkbox.borderRadius}`,
    },
    checkboxIconChecked: {
        background: `${theme.color.checkbox.active} url(${check}) no-repeat 7px center`,
        borderColor: `${theme.color.checkbox.borderActive}`,
        width: 30,
        height: 30,
    },
})

export const useReferralsStyles = () => ({
    pageTitle: {
        marginTop: 30,
    },
})
